import { useEffect, useState } from 'react';
import { DataGrid, GridColDef } from '@mui/x-data-grid';
import axios from 'axios';
import { Box, Typography } from '@mui/material';
import { OpenAPI } from '../../../../api';

export default function JobList() {
  const [jobs, setJobs] = useState<any[]>([]);
  
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchJobs = async () => {
      try {
        const response = await axios.get((OpenAPI.BASE || 'http://localhost:5051') + '/api/job/me', {
          withCredentials: true
        });
        setJobs(response.data.jobs); 
      } catch (error) {
        console.error('Error fetching jobs:', error);
      }
    };
    
    fetchJobs();
  }, []);


const columns: GridColDef[] = [
  { field: 'id', headerName: 'ID', width: 70 }, 
  { field: 'redditUrl', headerName: 'URL', width: 300 },
  { field: 'status', headerName: 'Státusz', width: 130 },
  { field: 'createdAt', headerName: 'Létrehozva', width: 200 },
];

  return (
    <Box sx={{ height: 400, width: '100%', p: 3 }}>
      <Typography variant="h4" gutterBottom>Elemzéseim</Typography>
      <DataGrid
        rows={jobs}
        columns={columns}
        loading={loading}
        getRowId={(row) => row.Id}
        initialState={{
          pagination: {
            paginationModel: { page: 0, pageSize: 5 },
          },
        }}
        pageSizeOptions={[5, 10]}
      />
    </Box>
  );
}